import BaseCtrl from 'edge/platform/base/BaseCtrl';
import { wizardParentState } from '../RouteConfig';
import startAddBuildingWizardFlow from '../flow';
import _ from 'lodash';

var fn = function fn($scope, $state, $stateParams, $injector, StateUtils) {
    var model = StateUtils.activeDataForState(true).model;
    $scope.flowModel = $state.get(wizardParentState).data.flow;
    $scope.location = _.find(model.lobData.commercialProperty.coverables.locations.value, function (location) {
        return location.publicID === $stateParams.model.selectedLocation.publicID;
    });
    $scope.building = _.find($scope.location.buildings, function (building) {
        return building.publicID === $stateParams.model.selectedBuilding.publicID;
    });
    $scope.coverages = $scope.building.coverages;

    var ctrl = Object.create(BaseCtrl);
    ctrl.init = function () {};

    if ($scope.location.isNew) {
        $scope.location.isNew = false;
    }

    ctrl.addAnotherBuilding = function (callback) {
        callback();
        startAddBuildingWizardFlow($injector);
    };

    $scope.editLocation = function () {
        $state.go('cpBuildingWizardEditLocation', { publicID: $scope.location.publicID, buildingPublicID: $scope.building.publicID });
    };

    $scope.next = function (next) {
        return next($stateParams.model);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', '$state', '$stateParams', '$injector', 'StateUtils'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/AddBuildingWizard/confirmation/ConfirmationCtrl.js
// module id = 983
// module chunks = 0